import $ from 'jquery';


export default () => {
    
    if($('.block-primary').length > 0) {
        //console.log('block primary');
    }
};



// WEBPACK FOOTER //
// ../views/partials/blocks/block-primary/block-primary.js